import dayjs from 'dayjs';

export function parseDayArrToString(arr) {
  if (!arr) return null;
  if (arr.filter((x) => x).length === 7) return 'täglich';
  if (arr[1] && arr[2] && arr[3] && arr[4] && arr[5] && arr[6] && !arr[0]) return 'Mo-Sa';
  if (arr[1] && arr[2] && arr[3] && arr[4] && arr[5] && !arr[6] && !arr[0]) return 'Mo-Fr';
  if (arr[1] && arr[2] && arr[3] && arr[4] && !arr[5] && !arr[6] && !arr[0]) return 'Mo-Do';

  let returnArray = [];
  for (let i = 0; i < arr.length; i++) {
    returnArray[i] = arr[i] ? mapIndexToDayString(i) : '';
  }

  let sunday = returnArray.shift();
  returnArray.push(sunday);
  returnArray = returnArray.filter((x) => x && x !== '');
  const lastElement = returnArray.pop();

  let returnStr = returnArray.join(', ');
  returnStr = returnArray.length > 0 ? returnStr + ' & ' + lastElement : lastElement;
  return returnStr;
}

export function mapIndexToDayString(i) {
  switch (i) {
    case 0:
      return 'Sonntag';
    case 1:
      return 'Montag';
    case 2:
      return 'Dienstag';
    case 3:
      return 'Mittwoch';
    case 4:
      return 'Donnerstag';
    case 5:
      return 'Freitag';
    case 6:
      return 'Samstag';
  }
}

export function parseSecondsToTime(seconds, addPostfix = true) {
  return dayjs()
    .startOf('day')
    .add(seconds, 'second')
    .format(`HH:mm ${addPostfix ? '[Uhr]' : ''}`);
}

export function isDtControlledAvailable(el) {
  if (el.dtControlled) {
    const now = dayjs();
    if (el.activeDays.findIndex((active, index) => active && index === now.day()) > -1) {
      if (el.timeControlled) {
        const startMoment = dayjs().startOf('day').add(el.timeFrom, 'second');
        const endMoment = dayjs().startOf('day').add(el.timeUntil, 'second');
        if (now.isAfter(startMoment) && now.isBefore(endMoment)) {
          return true;
        }
        return false;
      }
    } else {
      return false;
    }
  }
  return true;
}
